import CartOrderSummaryV2 from './CartOrderSummaryV2'

export default CartOrderSummaryV2
// eslint-disable-next-line import/export
export * from './CartOrderSummaryV2'
